export default __webpack_public_path__ + "static/media/3in1_ua_d.f869b77b.svg";